module.exports = __webpack_public_path__ + "img/682e4fe50b1dcc90d4e831fdda818dd8.png";